import React, { FC } from 'react'

import { BreadCrumbs } from 'components/block/Seo/BreadCrumbs/BreadCrumbs'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

export const LandingBreadCrumbs: FC<{ gender?: string }> = ({ gender }) => {
  const { seoLocation } = useShallowEqualSelector(
    ({ landingReducer: { seoLocation } }) => ({
      seoLocation,
    })
  )

  /**
   * Мы точно знаем что они есть.
   * Проверили там где вызываем данный компонент.
   */
  const _links = seoLocation!.ancestorsLinks!.map(({ url, text }) => ({
    url: gender ? `${url}/${gender}` : url,
    text,
  }))

  return <BreadCrumbs links={_links} />
}
